import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const TwoFASetupRequired = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleSetup2FA = () => {
    navigate('/2fa-setup');
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-error/10 via-background to-error/5 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-error/10 mb-6">
            <Icon name="ShieldAlert" className="w-10 h-10 text-error" />
          </div>
          <h1 className="text-3xl font-bold text-foreground mb-4">2FA Setup Required</h1>
          <p className="text-foreground-secondary">
            Your 24-hour setup period has expired. Two-factor authentication is mandatory for all accounts.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-border space-y-6">
          <div className="bg-error/5 border border-error/20 rounded-lg p-4">
            <div className="flex items-start">
              <Icon name="AlertCircle" className="w-5 h-5 text-error mt-0.5 mr-3 flex-shrink-0" />
              <div className="text-sm text-foreground-secondary">
                <p className="font-medium text-foreground mb-1">Access Restricted</p>
                <p>You must enable two-factor authentication to continue using your account. This adds an extra layer of security to protect your data.</p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Button
              onClick={handleSetup2FA}
              className="w-full bg-gradient-to-r from-primary to-secondary"
            >
              <Icon name="Shield" className="w-5 h-5 mr-2" />
              Set Up 2FA Now
            </Button>

            <Button
              onClick={handleSignOut}
              variant="ghost"
              className="w-full"
            >
              Sign Out
            </Button>
          </div>

          <div className="pt-4 border-t border-border">
            <div className="space-y-2">
              <p className="text-sm font-medium text-foreground">What you'll need:</p>
              <ul className="text-sm text-foreground-secondary space-y-1">
                <li className="flex items-center">
                  <Icon name="Check" className="w-4 h-4 text-success mr-2" />
                  Authenticator app (Google Authenticator, Authy, etc.)
                </li>
                <li className="flex items-center">
                  <Icon name="Check" className="w-4 h-4 text-success mr-2" />
                  5 minutes to complete setup
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-6">
          <Link to="/" className="text-sm text-foreground-secondary hover:text-foreground flex items-center justify-center">
            <Icon name="ArrowLeft" className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TwoFASetupRequired;